export const rootNamespace = "$root";
